import Control from "sap/ui/core/Control";
import RenderManager from "sap/ui/core/RenderManager";
import { MetadataOptions } from "sap/ui/core/Element";
import Icon from "sap/ui/core/Icon";
import { CommissionRequestStatus, ResponseCommissionRequestStatus } from "vamos/cockpit/model/api/vamos.private.api.types";
import ApiService from "vamos/cockpit/base/services/type/ApiService";

/**
 * @namespace vamos.cockpit.data.unrequiredrequest.control
 */
export default class CommissionRequestStatusIcon extends Control {


  static readonly metadata: MetadataOptions = {
    properties: {
      requestGuid: {
        type: "any",
        defaultValue: "",
      },
      isCommissionRequest: {
        type: "boolean",
        defaultValue: "",
      },
    },
    aggregations: {
      _icon: {
        type: "sap.ui.core.Icon",
        multiple: false,
        visibility: "hidden",
      },
    },
  };

  private async _resolveCommissionRequestStatus(): Promise<void> {

    if (!this.isCommissionRequest() && !this.getRequestGuid()) return;

    const requestGuid = this.getRequestGuid();
    let response = await ApiService.getInstance().getRestJsonData(`/request/validate-commission-request/${requestGuid}`) as ResponseCommissionRequestStatus;
    let path = "";
    let color = "";
      if (response.content === CommissionRequestStatus.NO_SUPPLIER_CONDITION) {
      path = "sap-icon://employee-rejections";
      color = "red";
      } else if (response.content === CommissionRequestStatus.MULTIPLE_SUPPLIER_CONDITIONS) {
      path = "sap-icon://add-employee";
      color = "#ffcc00";
    }
    const icon: Icon = this.getIcon();
    icon.setSrc(path);
    icon.setColor(color);
  }

  private isCommissionRequest(): boolean {
    return this.getProperty("isCommissionRequest");
  }

  private getRequestGuid(): any {
    return this.getProperty("requestGuid");
  }

  public setRequestGuid(requestGuid: any) {
    this.setProperty("requestGuid", requestGuid);
    this._resolveCommissionRequestStatus();
  }

  public setIsCommissionRequest(isCommissionRequest: boolean) {
    this.setProperty("isCommissionRequest", isCommissionRequest);
    this._resolveCommissionRequestStatus();
  }

  public getIcon(): Icon {
    return this.getAggregation("_icon") as Icon;
  }

  init(): void {
    this.setAggregation("_icon", new Icon());
  }

  renderer = {
    apiVersion: 4,
    render: (rm: RenderManager, control: CommissionRequestStatusIcon) => {
      rm.renderControl(control.getIcon() as Control);
    },
  };
};